/**
 * Constantes pour les raisons d'annulation avec suggestions contextuelles
 * Créé selon PLAN_TECHNIQUE_RAISONS_ANNULATION.md
 * Support analytics et internationalisation
 */

export const CANCELLATION_REASONS = {
  renter_cancellation: [
    'CHANGE_OF_PLANS',
    'WEATHER_CONDITIONS', 
    'TRANSPORT_ISSUE',
    'PERSONAL_EMERGENCY',
    'LISTING_NOT_AS_DESCRIBED',
    'OWNER_COMMUNICATION_ISSUE',
    'PRICE_TOO_HIGH',
    'NO_LONGER_NEEDED',
    'OTHER'
  ],
  
  owner_cancellation: [
    'EQUIPMENT_UNAVAILABLE',
    'EQUIPMENT_BREAKDOWN',
    'RENTER_ISSUE',
    'PERSONAL_EMERGENCY', 
    'DANGEROUS_WEATHER',
    'TERMS_VIOLATION',
    'SECURITY_CONCERN',
    'URGENT_MAINTENANCE',
    'OTHER'
  ],
  
  pickup_refusal_owner: [
    'EQUIPMENT_UNAVAILABLE',
    'TECHNICAL_ISSUE',
    'RENTER_ABSENT',
    'DANGEROUS_WEATHER',
    'SECURITY_ISSUE',
    'OTHER'
  ],
  
  pickup_refusal_renter: [
    'NOT_AS_DESCRIBED',
    'UNSATISFACTORY_CONDITION',
    'SECURITY_ISSUE', 
    'LAST_MINUTE_CHANGE',
    'DIFFERENT_EQUIPMENT',
    'OTHER'
  ],
  
  return_refusal_owner: [
    'DAMAGED_EQUIPMENT',
    'NOT_CLEANED',
    'LATE_RETURN',
    'INCOMPLETE_EQUIPMENT',
    'DAMAGE_CLAIMED',
    'OTHER'
  ],
  
  return_refusal_renter: [
    'ISSUE_DURING_RENTAL',
    'EQUIPMENT_FAILURE',
    'EARLY_RETURN_SAFETY',
    'SERVICE_UNSATISFACTORY',
    'OTHER'
  ]
};

export const REASON_CATEGORIES = {
  EQUIPMENT: 'equipment',
  COMMUNICATION: 'communication', 
  WEATHER: 'weather',
  PERSONAL: 'personal',
  SAFETY: 'safety',
  TERMS: 'terms',
  OTHER: 'other'
};

export const getReasonCategory = (reason) => {
  const categoryMap = {
    'EQUIPMENT_UNAVAILABLE': REASON_CATEGORIES.EQUIPMENT,
    'EQUIPMENT_BREAKDOWN': REASON_CATEGORIES.EQUIPMENT,
    'TECHNICAL_ISSUE': REASON_CATEGORIES.EQUIPMENT,
    'DAMAGED_EQUIPMENT': REASON_CATEGORIES.EQUIPMENT,
    'EQUIPMENT_FAILURE': REASON_CATEGORIES.EQUIPMENT,
    'DIFFERENT_EQUIPMENT': REASON_CATEGORIES.EQUIPMENT,
    'INCOMPLETE_EQUIPMENT': REASON_CATEGORIES.EQUIPMENT,
    
    'WEATHER_CONDITIONS': REASON_CATEGORIES.WEATHER,
    'DANGEROUS_WEATHER': REASON_CATEGORIES.WEATHER,
    
    'PERSONAL_EMERGENCY': REASON_CATEGORIES.PERSONAL,
    'CHANGE_OF_PLANS': REASON_CATEGORIES.PERSONAL,
    'NO_LONGER_NEEDED': REASON_CATEGORIES.PERSONAL,
    
    'SECURITY_CONCERN': REASON_CATEGORIES.SAFETY,
    'SECURITY_ISSUE': REASON_CATEGORIES.SAFETY,
    'EARLY_RETURN_SAFETY': REASON_CATEGORIES.SAFETY,
    
    'OWNER_COMMUNICATION_ISSUE': REASON_CATEGORIES.COMMUNICATION,
    'RENTER_ISSUE': REASON_CATEGORIES.COMMUNICATION,
    
    'TERMS_VIOLATION': REASON_CATEGORIES.TERMS,
    'LISTING_NOT_AS_DESCRIBED': REASON_CATEGORIES.TERMS,
    'NOT_AS_DESCRIBED': REASON_CATEGORIES.TERMS,
    
    'OTHER': REASON_CATEGORIES.OTHER
  };
  
  return categoryMap[reason] || REASON_CATEGORIES.OTHER;
};

// Contextes de source pour analytics
export const CANCELLATION_CONTEXTS = {
  RENTER_LIST: 'renter_list',
  OWNER_LIST: 'owner_list', 
  PICKUP_REFUSAL: 'pickup_refusal',
  RETURN_REFUSAL: 'return_refusal'
};

// Configuration validation
export const VALIDATION_RULES = {
  MIN_REASON_LENGTH: 10,
  MAX_REASON_LENGTH: 500,
  REQUIRED_FOR_CUSTOM: true
};

export default {
  CANCELLATION_REASONS,
  REASON_CATEGORIES,
  CANCELLATION_CONTEXTS,
  VALIDATION_RULES,
  getReasonCategory
};
